import { defineMessages } from "./define";

export const authMessages = defineMessages({
  ru: {
    "auth.login_title": "С возвращением",
    "auth.login_subtitle": "Войдите, чтобы продолжить работу с активами",
    "auth.login_submit": "Войти",
    "auth.signup_title": "Создать аккаунт",
    "auth.signup_subtitle": "Получите доступ к коллекциям",
    "auth.signup_submit": "Зарегистрироваться",
    "auth.reset_title": "Новый пароль",
    "auth.reset_subtitle": "Укажите email и новый пароль для аккаунта",
    "auth.reset_submit": "Обновить пароль",
    "auth.code_required": "Введите код подтверждения.",
    "auth.repeat_password_required": "Повторите пароль.",
    "auth.passwords_mismatch": "Пароли не совпадают.",
    "auth.password_required": "Укажите пароль.",
    "auth.agreement_required": "Необходимо принять пользовательское соглашение.",
    "auth.reset_success_title": "Пароль обновлён",
    "auth.reset_success_desc": "Теперь можно войти с новым паролем.",
    "auth.go_to_login": "Перейти ко входу",
    "auth.two_factor_eyebrow": "Двухфакторная защита",
    "auth.two_factor_title": "Подтвердите вход",
    "auth.two_factor_desc": "Введите код из приложения-аутентификатора.",
    "auth.code_label": "Код подтверждения",
    "auth.code_placeholder": "6 цифр",
    "auth.checking": "Проверяем…",
    "auth.confirm": "Подтвердить",
    "auth.back": "Назад",
    "auth.secure_access": "Безопасный доступ",
    "auth.email_label": "Email",
    "auth.password_label": "Пароль",
    "auth.new_password_label": "Новый пароль",
    "auth.repeat_password_label": "Повторите пароль",
    "auth.invite_label": "Код приглашения (необязательно)",
    "auth.remember_me": "Запомнить меня",
    "auth.agreement_accept": "Принимаю {link}",
    "auth.agreement_link": "пользовательское соглашение",
    "auth.newsletter": "Получать новости продукта",
    "auth.sending": "Отправляем…",
    "auth.have_account": "Уже есть аккаунт",
    "auth.forgot_password": "Забыли пароль?",
    "auth.art_line1": "Цифровое владение.",
    "auth.art_line2": "Прозрачно по замыслу.",
    "auth.link_incomplete_title": "Ссылка неполная",
    "auth.link_incomplete_desc": "В ссылке отсутствует ключ активации.",
    "auth.confirming_email": "Подтверждаем email",
    "auth.email_confirmed_title": "Email подтверждён",
    "auth.email_confirmed_desc": "Аккаунт активирован. Можно продолжить работу.",
    "auth.continue": "Продолжить",
    "auth.preparing_invite": "Подготавливаем приглашение",
    "auth.resent": "Письмо отправлено повторно.",
    "auth.email_verification": "Подтверждение почты",
    "auth.verify_email_title": "Подтвердите электронную почту",
    "auth.verify_email_desc": "Мы отправили ссылку для активации на адрес вашего аккаунта. После подтверждения вернитесь сюда и обновите статус.",
    "auth.email_confirmed_button": "Я подтвердил почту",
    "auth.resend_email": "Отправить письмо снова",
    "auth.username_length": "Имя пользователя должно содержать от 3 до 20 символов.",
    "auth.welcome": "Добро пожаловать",
    "auth.choose_username": "Введите имя пользователя",
    "auth.username_hint": "Так вас будут видеть в профиле. Имя можно изменить позже.",
    "auth.username_label": "Имя пользователя",
    "auth.saving": "Сохраняем…",
    "auth.skip": "Пропустить",
    "auth.status_aria": "Статус аккаунта",
    "auth.status_account": "Аккаунт",
    "auth.status_blocked": "Заблокирован",
    "auth.status_verification": "Верификация",
    "auth.status_verified": "Верифицирован",
    "auth.status_not_verified": "Не верифицирован",
    "auth.status_aml": "AML",
    "auth.status_passed": "Пройден",
    "auth.status_not_passed": "Не пройден",
    "auth.status_withdrawals": "Вывод средств",
    "auth.status_available": "Доступен",
    "auth.status_restricted": "Ограничен",
    "auth.chip_verified": "Аккаунт верифицирован",
    "auth.chip_not_verified": "Аккаунт не верифицирован",
    "auth.chip_withdraw_available": "Вывод доступен",
    "auth.chip_withdraw_restricted": "Вывод ограничен",
    "auth.chip_aml_passed": "AML пройден",
    "auth.chip_aml_not_passed": "AML не пройден",
    "auth.main_nav": "Основная навигация",
    "auth.mobile_nav": "Мобильная навигация",
    "auth.tfa_enter_code": "Введите код из приложения.",
    "auth.tfa_enabled": "Двухфакторная защита включена.",
    "auth.tfa_disabled": "Двухфакторная защита отключена.",
    "auth.tfa_unavailable": "Двухфакторная защита сейчас недоступна. Попробуйте позже.",
    "auth.tfa_title": "Двухфакторная защита",
    "auth.tfa_on_desc": "Включена: при входе потребуется код из приложения-аутентификатора.",
    "auth.tfa_off_desc": "Добавьте одноразовые коды из приложения-аутентификатора для входа в аккаунт.",
    "auth.tfa_apps_hint": "Подойдёт любое приложение-генератор кодов:",
    "auth.tfa_secret_label": "Секретный ключ (введите вручную в приложении-аутентификаторе)",
    "auth.tfa_disable": "Отключить",
    "auth.tfa_preparing": "Готовим…",
    "auth.tfa_enable": "Включить",
    "auth.tfa_setup_desc": "Отсканируйте QR-код в приложении-аутентификаторе или введите ключ вручную, затем подтвердите кодом.",
    "auth.tfa_qr_alt": "QR-код для приложения-аутентификатора",
    "auth.cancel": "Отмена",
    "auth.tfa_disable_title": "Отключить двухфакторную защиту?",
    "auth.tfa_disable_desc": "Это снизит безопасность аккаунта: для входа будет достаточно одного пароля.",
    "auth.devices_loading": "Загружаем устройства",
    "auth.devices_title": "Устройства",
    "auth.devices_unavailable": "Список устройств сейчас недоступен. Попробуйте позже.",
    "auth.devices_desc": "Здесь показаны устройства, на которых выполнен вход в аккаунт.",
    "auth.devices_empty": "Активных сессий не найдено.",
    "auth.device_unknown": "Неизвестное устройство",
    "auth.device_current": "это устройство",
    "auth.device_terminate": "Завершить",
    "auth.devices_terminating": "Завершаем…",
    "auth.devices_terminate_others": "Завершить все остальные сессии",
    "auth.saved": "Изменения сохранены.",
    "auth.new_username_required": "Укажите новое имя пользователя.",
    "auth.new_email_required": "Укажите новый email.",
    "auth.new_passwords_mismatch": "Новые пароли не совпадают.",
    "auth.current_password_required": "Укажите текущий пароль.",
    "auth.password_updated": "Пароль обновлён.",
    "auth.avatar_type": "Используйте JPEG, PNG или WebP.",
    "auth.avatar_size": "Размер изображения не должен превышать 5 МБ.",
    "auth.avatar_updated": "Аватар обновлён.",
    "auth.account_title": "Аккаунт",
    "auth.account_since": "Вы с нами с {date}",
    "auth.section_profile": "Профиль",
    "auth.section_security": "Безопасность",
    "auth.section_achievements": "Достижения",
    "auth.section_preferences": "Предпочтения",
    "auth.partial_unavailable": "Часть операций временно недоступна.",
    "auth.avatar_alt": "Аватар пользователя",
    "auth.avatar_upload": "Загрузить новый аватар",
    "auth.verified_account": "Проверенный аккаунт",
    "auth.balance": "Баланс",
    "auth.turnover": "Оборот",
    "auth.change_username": "Изменить имя",
    "auth.change_email": "Изменить email",
    "auth.email_change_hint": "Текущий: {email}. После сохранения на новый адрес придёт письмо — почта сменится, когда вы перейдёте по ссылке из него.",
    "auth.change_password_title": "Смена пароля",
    "auth.password_policy": "Новый пароль: 6–20 символов, заглавная и строчная буквы, цифра и специальный символ.",
    "auth.current_password_label": "Текущий пароль",
    "auth.repeat_new_password_label": "Повторите новый пароль",
    "auth.updating": "Обновляем…",
    "auth.language_currency": "Язык и валюта",
    "auth.currency_label": "Валюта",
  },
  en: {
    "auth.login_title": "Welcome back",
    "auth.login_subtitle": "Log in to continue working with your assets",
    "auth.login_submit": "Log in",
    "auth.signup_title": "Create an account",
    "auth.signup_subtitle": "Get access to collections",
    "auth.signup_submit": "Sign up",
    "auth.reset_title": "New password",
    "auth.reset_subtitle": "Enter your email and a new password for the account",
    "auth.reset_submit": "Update password",
    "auth.code_required": "Enter the confirmation code.",
    "auth.repeat_password_required": "Repeat the password.",
    "auth.passwords_mismatch": "Passwords don't match.",
    "auth.password_required": "Enter your password.",
    "auth.agreement_required": "You must accept the user agreement.",
    "auth.reset_success_title": "Password updated",
    "auth.reset_success_desc": "You can now log in with your new password.",
    "auth.go_to_login": "Go to login",
    "auth.two_factor_eyebrow": "Two-factor",
    "auth.two_factor_title": "Confirm sign-in",
    "auth.two_factor_desc": "Enter the code from your authenticator app.",
    "auth.code_label": "Confirmation code",
    "auth.code_placeholder": "6 digits",
    "auth.checking": "Checking…",
    "auth.confirm": "Confirm",
    "auth.back": "Back",
    "auth.secure_access": "Secure access",
    "auth.email_label": "Email",
    "auth.password_label": "Password",
    "auth.new_password_label": "New password",
    "auth.repeat_password_label": "Repeat password",
    "auth.invite_label": "Invite code (optional)",
    "auth.remember_me": "Remember me",
    "auth.agreement_accept": "I accept the {link}",
    "auth.agreement_link": "user agreement",
    "auth.newsletter": "Receive product news",
    "auth.sending": "Sending…",
    "auth.have_account": "Already have an account",
    "auth.forgot_password": "Forgot password?",
    "auth.art_line1": "Digital ownership.",
    "auth.art_line2": "Clear by design.",
    "auth.link_incomplete_title": "Incomplete link",
    "auth.link_incomplete_desc": "The link is missing the activation key.",
    "auth.confirming_email": "Confirming your email",
    "auth.email_confirmed_title": "Email confirmed",
    "auth.email_confirmed_desc": "Your account is activated. You can continue.",
    "auth.continue": "Continue",
    "auth.preparing_invite": "Preparing your invitation",
    "auth.resent": "The email has been sent again.",
    "auth.email_verification": "Email verification",
    "auth.verify_email_title": "Confirm your email",
    "auth.verify_email_desc": "We've sent an activation link to your account's email address. Once you've confirmed it, come back here and refresh the status.",
    "auth.email_confirmed_button": "I've confirmed my email",
    "auth.resend_email": "Send the email again",
    "auth.username_length": "The username must be 3 to 20 characters long.",
    "auth.welcome": "Welcome",
    "auth.choose_username": "Enter a username",
    "auth.username_hint": "This is how others will see you in your profile. You can change it later.",
    "auth.username_label": "Username",
    "auth.saving": "Saving…",
    "auth.skip": "Skip",
    "auth.status_aria": "Account status",
    "auth.status_account": "Account",
    "auth.status_blocked": "Blocked",
    "auth.status_verification": "Verification",
    "auth.status_verified": "Verified",
    "auth.status_not_verified": "Not verified",
    "auth.status_aml": "AML",
    "auth.status_passed": "Passed",
    "auth.status_not_passed": "Not passed",
    "auth.status_withdrawals": "Withdrawals",
    "auth.status_available": "Available",
    "auth.status_restricted": "Restricted",
    "auth.chip_verified": "Account verified",
    "auth.chip_not_verified": "Account not verified",
    "auth.chip_withdraw_available": "Withdrawals available",
    "auth.chip_withdraw_restricted": "Withdrawals restricted",
    "auth.chip_aml_passed": "AML passed",
    "auth.chip_aml_not_passed": "AML not passed",
    "auth.main_nav": "Main navigation",
    "auth.mobile_nav": "Mobile navigation",
    "auth.tfa_enter_code": "Enter the code from the app.",
    "auth.tfa_enabled": "Two-factor protection is enabled.",
    "auth.tfa_disabled": "Two-factor protection is disabled.",
    "auth.tfa_unavailable": "Two-factor protection is currently unavailable. Try again later.",
    "auth.tfa_title": "Two-factor protection",
    "auth.tfa_on_desc": "Enabled: signing in will require a code from your authenticator app.",
    "auth.tfa_off_desc": "Add one-time codes from an authenticator app to sign in to your account.",
    "auth.tfa_apps_hint": "Any authenticator app will work:",
    "auth.tfa_secret_label": "Secret key (enter it manually in your authenticator app)",
    "auth.tfa_disable": "Disable",
    "auth.tfa_preparing": "Preparing…",
    "auth.tfa_enable": "Enable",
    "auth.tfa_setup_desc": "Scan the QR code in your authenticator app or enter the key manually, then confirm with a code.",
    "auth.tfa_qr_alt": "QR code for the authenticator app",
    "auth.cancel": "Cancel",
    "auth.tfa_disable_title": "Disable two-factor protection?",
    "auth.tfa_disable_desc": "This lowers your account security: a password alone will be enough to sign in.",
    "auth.devices_loading": "Loading devices",
    "auth.devices_title": "Devices",
    "auth.devices_unavailable": "The device list is currently unavailable. Try again later.",
    "auth.devices_desc": "These are the devices signed in to your account.",
    "auth.devices_empty": "No active sessions found.",
    "auth.device_unknown": "Unknown device",
    "auth.device_current": "this device",
    "auth.device_terminate": "End",
    "auth.devices_terminating": "Ending…",
    "auth.devices_terminate_others": "End all other sessions",
    "auth.saved": "Changes saved.",
    "auth.new_username_required": "Enter a new username.",
    "auth.new_email_required": "Enter a new email.",
    "auth.new_passwords_mismatch": "The new passwords don't match.",
    "auth.current_password_required": "Enter your current password.",
    "auth.password_updated": "Password updated.",
    "auth.avatar_type": "Use JPEG, PNG or WebP.",
    "auth.avatar_size": "The image must not exceed 5 MB.",
    "auth.avatar_updated": "Avatar updated.",
    "auth.account_title": "Account",
    "auth.account_since": "With us since {date}",
    "auth.section_profile": "Profile",
    "auth.section_security": "Security",
    "auth.section_achievements": "Achievements",
    "auth.section_preferences": "Preferences",
    "auth.partial_unavailable": "Some operations are temporarily unavailable.",
    "auth.avatar_alt": "User avatar",
    "auth.avatar_upload": "Upload a new avatar",
    "auth.verified_account": "Verified account",
    "auth.balance": "Balance",
    "auth.turnover": "Turnover",
    "auth.change_username": "Change name",
    "auth.change_email": "Change email",
    "auth.email_change_hint": "Current: {email}. After saving, we'll email the new address — it changes once you follow the link from that email.",
    "auth.change_password_title": "Change password",
    "auth.password_policy": "New password: 6–20 characters, with an uppercase and a lowercase letter, a digit and a special character.",
    "auth.current_password_label": "Current password",
    "auth.repeat_new_password_label": "Repeat the new password",
    "auth.updating": "Updating…",
    "auth.language_currency": "Language and currency",
    "auth.currency_label": "Currency",
  },
  ua: {
    "auth.login_title": "З поверненням",
    "auth.login_subtitle": "Увійдіть, щоб продовжити роботу з активами",
    "auth.login_submit": "Увійти",
    "auth.signup_title": "Створити акаунт",
    "auth.signup_subtitle": "Отримайте доступ до колекцій",
    "auth.signup_submit": "Зареєструватися",
    "auth.reset_title": "Новий пароль",
    "auth.reset_subtitle": "Вкажіть email і новий пароль для акаунта",
    "auth.reset_submit": "Оновити пароль",
    "auth.code_required": "Введіть код підтвердження.",
    "auth.repeat_password_required": "Повторіть пароль.",
    "auth.passwords_mismatch": "Паролі не збігаються.",
    "auth.password_required": "Вкажіть пароль.",
    "auth.agreement_required": "Необхідно прийняти угоду користувача.",
    "auth.reset_success_title": "Пароль оновлено",
    "auth.reset_success_desc": "Тепер можна увійти з новим паролем.",
    "auth.go_to_login": "Перейти до входу",
    "auth.two_factor_eyebrow": "Двофакторний захист",
    "auth.two_factor_title": "Підтвердьте вхід",
    "auth.two_factor_desc": "Введіть код із застосунку-автентифікатора.",
    "auth.code_label": "Код підтвердження",
    "auth.code_placeholder": "6 цифр",
    "auth.checking": "Перевіряємо…",
    "auth.confirm": "Підтвердити",
    "auth.back": "Назад",
    "auth.secure_access": "Безпечний доступ",
    "auth.email_label": "Email",
    "auth.password_label": "Пароль",
    "auth.new_password_label": "Новий пароль",
    "auth.repeat_password_label": "Повторіть пароль",
    "auth.invite_label": "Код запрошення (необов'язково)",
    "auth.remember_me": "Запам'ятати мене",
    "auth.agreement_accept": "Приймаю {link}",
    "auth.agreement_link": "угоду користувача",
    "auth.newsletter": "Отримувати новини продукту",
    "auth.sending": "Надсилаємо…",
    "auth.have_account": "Вже є акаунт",
    "auth.forgot_password": "Забули пароль?",
    "auth.art_line1": "Цифрове володіння.",
    "auth.art_line2": "Прозоро за задумом.",
    "auth.link_incomplete_title": "Посилання неповне",
    "auth.link_incomplete_desc": "У посиланні відсутній ключ активації.",
    "auth.confirming_email": "Підтверджуємо email",
    "auth.email_confirmed_title": "Email підтверджено",
    "auth.email_confirmed_desc": "Акаунт активовано. Можна продовжити роботу.",
    "auth.continue": "Продовжити",
    "auth.preparing_invite": "Готуємо запрошення",
    "auth.resent": "Лист надіслано повторно.",
    "auth.email_verification": "Підтвердження пошти",
    "auth.verify_email_title": "Підтвердьте електронну пошту",
    "auth.verify_email_desc": "Ми надіслали посилання для активації на адресу вашого акаунта. Після підтвердження поверніться сюди й оновіть статус.",
    "auth.email_confirmed_button": "Я підтвердив пошту",
    "auth.resend_email": "Надіслати лист знову",
    "auth.username_length": "Ім'я користувача має містити від 3 до 20 символів.",
    "auth.welcome": "Ласкаво просимо",
    "auth.choose_username": "Введіть ім'я користувача",
    "auth.username_hint": "Так вас бачитимуть у профілі. Ім'я можна змінити пізніше.",
    "auth.username_label": "Ім'я користувача",
    "auth.saving": "Зберігаємо…",
    "auth.skip": "Пропустити",
    "auth.status_aria": "Статус акаунта",
    "auth.status_account": "Акаунт",
    "auth.status_blocked": "Заблоковано",
    "auth.status_verification": "Верифікація",
    "auth.status_verified": "Верифіковано",
    "auth.status_not_verified": "Не верифіковано",
    "auth.status_aml": "AML",
    "auth.status_passed": "Пройдено",
    "auth.status_not_passed": "Не пройдено",
    "auth.status_withdrawals": "Виведення коштів",
    "auth.status_available": "Доступне",
    "auth.status_restricted": "Обмежене",
    "auth.chip_verified": "Акаунт верифіковано",
    "auth.chip_not_verified": "Акаунт не верифіковано",
    "auth.chip_withdraw_available": "Виведення доступне",
    "auth.chip_withdraw_restricted": "Виведення обмежене",
    "auth.chip_aml_passed": "AML пройдено",
    "auth.chip_aml_not_passed": "AML не пройдено",
    "auth.main_nav": "Основна навігація",
    "auth.mobile_nav": "Мобільна навігація",
    "auth.tfa_enter_code": "Введіть код із застосунку.",
    "auth.tfa_enabled": "Двофакторний захист увімкнено.",
    "auth.tfa_disabled": "Двофакторний захист вимкнено.",
    "auth.tfa_unavailable": "Двофакторний захист наразі недоступний. Спробуйте пізніше.",
    "auth.tfa_title": "Двофакторний захист",
    "auth.tfa_on_desc": "Увімкнено: під час входу знадобиться код із застосунку-автентифікатора.",
    "auth.tfa_off_desc": "Додайте одноразові коди із застосунку-автентифікатора для входу в акаунт.",
    "auth.tfa_apps_hint": "Підійде будь-який застосунок-генератор кодів:",
    "auth.tfa_secret_label": "Секретний ключ (введіть вручну в застосунку-автентифікаторі)",
    "auth.tfa_disable": "Вимкнути",
    "auth.tfa_preparing": "Готуємо…",
    "auth.tfa_enable": "Увімкнути",
    "auth.tfa_setup_desc": "Відскануйте QR-код у застосунку-автентифікаторі або введіть ключ вручну, потім підтвердьте кодом.",
    "auth.tfa_qr_alt": "QR-код для застосунку-автентифікатора",
    "auth.cancel": "Скасувати",
    "auth.tfa_disable_title": "Вимкнути двофакторний захист?",
    "auth.tfa_disable_desc": "Це знизить безпеку акаунта: для входу буде достатньо лише пароля.",
    "auth.devices_loading": "Завантажуємо пристрої",
    "auth.devices_title": "Пристрої",
    "auth.devices_unavailable": "Список пристроїв наразі недоступний. Спробуйте пізніше.",
    "auth.devices_desc": "Тут показано пристрої, на яких виконано вхід в акаунт.",
    "auth.devices_empty": "Активних сесій не знайдено.",
    "auth.device_unknown": "Невідомий пристрій",
    "auth.device_current": "цей пристрій",
    "auth.device_terminate": "Завершити",
    "auth.devices_terminating": "Завершуємо…",
    "auth.devices_terminate_others": "Завершити всі інші сесії",
    "auth.saved": "Зміни збережено.",
    "auth.new_username_required": "Вкажіть нове ім'я користувача.",
    "auth.new_email_required": "Вкажіть новий email.",
    "auth.new_passwords_mismatch": "Нові паролі не збігаються.",
    "auth.current_password_required": "Вкажіть поточний пароль.",
    "auth.password_updated": "Пароль оновлено.",
    "auth.avatar_type": "Використовуйте JPEG, PNG або WebP.",
    "auth.avatar_size": "Розмір зображення не має перевищувати 5 МБ.",
    "auth.avatar_updated": "Аватар оновлено.",
    "auth.account_title": "Акаунт",
    "auth.account_since": "Ви з нами з {date}",
    "auth.section_profile": "Профіль",
    "auth.section_security": "Безпека",
    "auth.section_achievements": "Досягнення",
    "auth.section_preferences": "Уподобання",
    "auth.partial_unavailable": "Частина операцій тимчасово недоступна.",
    "auth.avatar_alt": "Аватар користувача",
    "auth.avatar_upload": "Завантажити новий аватар",
    "auth.verified_account": "Перевірений акаунт",
    "auth.balance": "Баланс",
    "auth.turnover": "Оборот",
    "auth.change_username": "Змінити ім'я",
    "auth.change_email": "Змінити email",
    "auth.email_change_hint": "Поточна: {email}. Після збереження на нову адресу надійде лист — пошта зміниться, коли ви перейдете за посиланням із нього.",
    "auth.change_password_title": "Зміна пароля",
    "auth.password_policy": "Новий пароль: 6–20 символів, велика й мала літери, цифра та спеціальний символ.",
    "auth.current_password_label": "Поточний пароль",
    "auth.repeat_new_password_label": "Повторіть новий пароль",
    "auth.updating": "Оновлюємо…",
    "auth.language_currency": "Мова та валюта",
    "auth.currency_label": "Валюта",
  },
  bl: {
    "auth.login_title": "З вяртаннем",
    "auth.login_subtitle": "Увайдзіце, каб працягнуць працу з актывамі",
    "auth.login_submit": "Увайсці",
    "auth.signup_title": "Стварыць акаунт",
    "auth.signup_subtitle": "Атрымайце доступ да калекцый",
    "auth.signup_submit": "Зарэгістравацца",
    "auth.reset_title": "Новы пароль",
    "auth.reset_subtitle": "Укажыце email і новы пароль для акаўнта",
    "auth.reset_submit": "Абнавіць пароль",
    "auth.code_required": "Увядзіце код пацвярджэння.",
    "auth.repeat_password_required": "Паўтарыце пароль.",
    "auth.passwords_mismatch": "Паролі не супадаюць.",
    "auth.password_required": "Укажыце пароль.",
    "auth.agreement_required": "Неабходна прыняць карыстальніцкае пагадненне.",
    "auth.reset_success_title": "Пароль абноўлены",
    "auth.reset_success_desc": "Цяпер можна ўвайсці з новым паролем.",
    "auth.go_to_login": "Перайсці да ўваходу",
    "auth.two_factor_eyebrow": "Двухфактарная абарона",
    "auth.two_factor_title": "Пацвердзіце ўваход",
    "auth.two_factor_desc": "Увядзіце код з праграмы-аўтэнтыфікатара.",
    "auth.code_label": "Код пацвярджэння",
    "auth.code_placeholder": "6 лічбаў",
    "auth.checking": "Правяраем…",
    "auth.confirm": "Пацвердзіць",
    "auth.back": "Назад",
    "auth.secure_access": "Бяспечны доступ",
    "auth.email_label": "Email",
    "auth.password_label": "Пароль",
    "auth.new_password_label": "Новы пароль",
    "auth.repeat_password_label": "Паўтарыце пароль",
    "auth.invite_label": "Код запрашэння (неабавязкова)",
    "auth.remember_me": "Запомніць мяне",
    "auth.agreement_accept": "Прымаю {link}",
    "auth.agreement_link": "карыстальніцкае пагадненне",
    "auth.newsletter": "Атрымліваць навіны прадукту",
    "auth.sending": "Адпраўляем…",
    "auth.have_account": "Ужо ёсць акаунт",
    "auth.forgot_password": "Забылі пароль?",
    "auth.art_line1": "Лічбавае валоданне.",
    "auth.art_line2": "Празрыста па задуме.",
    "auth.link_incomplete_title": "Спасылка няпоўная",
    "auth.link_incomplete_desc": "У спасылцы адсутнічае ключ актывацыі.",
    "auth.confirming_email": "Пацвярджаем email",
    "auth.email_confirmed_title": "Email пацверджаны",
    "auth.email_confirmed_desc": "Акаунт актываваны. Можна працягнуць працу.",
    "auth.continue": "Працягнуць",
    "auth.preparing_invite": "Рыхтуем запрашэнне",
    "auth.resent": "Ліст адпраўлены паўторна.",
    "auth.email_verification": "Пацвярджэнне пошты",
    "auth.verify_email_title": "Пацвердзіце электронную пошту",
    "auth.verify_email_desc": "Мы адправілі спасылку для актывацыі на адрас вашага акаўнта. Пасля пацвярджэння вярніцеся сюды і абнавіце статус.",
    "auth.email_confirmed_button": "Я пацвердзіў пошту",
    "auth.resend_email": "Адправіць ліст зноў",
    "auth.username_length": "Імя карыстальніка павінна ўтрымліваць ад 3 да 20 сімвалаў.",
    "auth.welcome": "Сардэчна запрашаем",
    "auth.choose_username": "Увядзіце імя карыстальніка",
    "auth.username_hint": "Так вас будуць бачыць у профілі. Імя можна змяніць пазней.",
    "auth.username_label": "Імя карыстальніка",
    "auth.saving": "Захоўваем…",
    "auth.skip": "Прапусціць",
    "auth.status_aria": "Статус акаўнта",
    "auth.status_account": "Акаунт",
    "auth.status_blocked": "Заблакаваны",
    "auth.status_verification": "Верыфікацыя",
    "auth.status_verified": "Верыфікаваны",
    "auth.status_not_verified": "Не верыфікаваны",
    "auth.status_aml": "AML",
    "auth.status_passed": "Пройдзены",
    "auth.status_not_passed": "Не пройдзены",
    "auth.status_withdrawals": "Вывад сродкаў",
    "auth.status_available": "Даступны",
    "auth.status_restricted": "Абмежаваны",
    "auth.chip_verified": "Акаунт верыфікаваны",
    "auth.chip_not_verified": "Акаунт не верыфікаваны",
    "auth.chip_withdraw_available": "Вывад даступны",
    "auth.chip_withdraw_restricted": "Вывад абмежаваны",
    "auth.chip_aml_passed": "AML пройдзены",
    "auth.chip_aml_not_passed": "AML не пройдзены",
    "auth.main_nav": "Асноўная навігацыя",
    "auth.mobile_nav": "Мабільная навігацыя",
    "auth.tfa_enter_code": "Увядзіце код з праграмы.",
    "auth.tfa_enabled": "Двухфактарная абарона ўключана.",
    "auth.tfa_disabled": "Двухфактарная абарона адключана.",
    "auth.tfa_unavailable": "Двухфактарная абарона зараз недаступная. Паспрабуйце пазней.",
    "auth.tfa_title": "Двухфактарная абарона",
    "auth.tfa_on_desc": "Уключана: пры ўваходзе спатрэбіцца код з праграмы-аўтэнтыфікатара.",
    "auth.tfa_off_desc": "Дадайце аднаразовыя коды з праграмы-аўтэнтыфікатара для ўваходу ў акаунт.",
    "auth.tfa_apps_hint": "Падыдзе любая праграма-генератар кодаў:",
    "auth.tfa_secret_label": "Сакрэтны ключ (увядзіце ўручную ў праграме-аўтэнтыфікатары)",
    "auth.tfa_disable": "Адключыць",
    "auth.tfa_preparing": "Рыхтуем…",
    "auth.tfa_enable": "Уключыць",
    "auth.tfa_setup_desc": "Адсканіруйце QR-код у праграме-аўтэнтыфікатары або ўвядзіце ключ уручную, потым пацвердзіце кодам.",
    "auth.tfa_qr_alt": "QR-код для праграмы-аўтэнтыфікатара",
    "auth.cancel": "Адмена",
    "auth.tfa_disable_title": "Адключыць двухфактарную абарону?",
    "auth.tfa_disable_desc": "Гэта знізіць бяспеку акаўнта: для ўваходу будзе дастаткова аднаго пароля.",
    "auth.devices_loading": "Загружаем прылады",
    "auth.devices_title": "Прылады",
    "auth.devices_unavailable": "Спіс прылад зараз недаступны. Паспрабуйце пазней.",
    "auth.devices_desc": "Тут паказаны прылады, на якіх выкананы ўваход у акаунт.",
    "auth.devices_empty": "Актыўных сесій не знойдзена.",
    "auth.device_unknown": "Невядомая прылада",
    "auth.device_current": "гэтая прылада",
    "auth.device_terminate": "Завяршыць",
    "auth.devices_terminating": "Завяршаем…",
    "auth.devices_terminate_others": "Завяршыць усе астатнія сесіі",
    "auth.saved": "Змены захаваны.",
    "auth.new_username_required": "Укажыце новае імя карыстальніка.",
    "auth.new_email_required": "Укажыце новы email.",
    "auth.new_passwords_mismatch": "Новыя паролі не супадаюць.",
    "auth.current_password_required": "Укажыце бягучы пароль.",
    "auth.password_updated": "Пароль абноўлены.",
    "auth.avatar_type": "Выкарыстоўвайце JPEG, PNG або WebP.",
    "auth.avatar_size": "Памер выявы не павінен перавышаць 5 МБ.",
    "auth.avatar_updated": "Аватар абноўлены.",
    "auth.account_title": "Акаунт",
    "auth.account_since": "Вы з намі з {date}",
    "auth.section_profile": "Профіль",
    "auth.section_security": "Бяспека",
    "auth.section_achievements": "Дасягненні",
    "auth.section_preferences": "Перавагі",
    "auth.partial_unavailable": "Частка аперацый часова недаступная.",
    "auth.avatar_alt": "Аватар карыстальніка",
    "auth.avatar_upload": "Загрузіць новы аватар",
    "auth.verified_account": "Правераны акаунт",
    "auth.balance": "Баланс",
    "auth.turnover": "Абарот",
    "auth.change_username": "Змяніць імя",
    "auth.change_email": "Змяніць email",
    "auth.email_change_hint": "Бягучая: {email}. Пасля захавання на новы адрас прыйдзе ліст — пошта зменіцца, калі вы пяройдзеце па спасылцы з яго.",
    "auth.change_password_title": "Змена пароля",
    "auth.password_policy": "Новы пароль: 6–20 сімвалаў, вялікая і малая літары, лічба і спецыяльны сімвал.",
    "auth.current_password_label": "Бягучы пароль",
    "auth.repeat_new_password_label": "Паўтарыце новы пароль",
    "auth.updating": "Абнаўляем…",
    "auth.language_currency": "Мова і валюта",
    "auth.currency_label": "Валюта",
  },
  de: {
    "auth.login_title": "Willkommen zurück",
    "auth.login_subtitle": "Melden Sie sich an, um mit Ihren Assets weiterzuarbeiten",
    "auth.login_submit": "Anmelden",
    "auth.signup_title": "Konto erstellen",
    "auth.signup_subtitle": "Erhalten Sie Zugang zu Kollektionen",
    "auth.signup_submit": "Registrieren",
    "auth.reset_title": "Neues Passwort",
    "auth.reset_subtitle": "Geben Sie Ihre E-Mail-Adresse und ein neues Passwort für das Konto ein",
    "auth.reset_submit": "Passwort aktualisieren",
    "auth.code_required": "Geben Sie den Bestätigungscode ein.",
    "auth.repeat_password_required": "Wiederholen Sie das Passwort.",
    "auth.passwords_mismatch": "Die Passwörter stimmen nicht überein.",
    "auth.password_required": "Geben Sie Ihr Passwort ein.",
    "auth.agreement_required": "Sie müssen die Nutzungsvereinbarung akzeptieren.",
    "auth.reset_success_title": "Passwort aktualisiert",
    "auth.reset_success_desc": "Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
    "auth.go_to_login": "Zur Anmeldung",
    "auth.two_factor_eyebrow": "Zwei-Faktor",
    "auth.two_factor_title": "Anmeldung bestätigen",
    "auth.two_factor_desc": "Geben Sie den Code aus Ihrer Authenticator-App ein.",
    "auth.code_label": "Bestätigungscode",
    "auth.code_placeholder": "6 Ziffern",
    "auth.checking": "Wird geprüft…",
    "auth.confirm": "Bestätigen",
    "auth.back": "Zurück",
    "auth.secure_access": "Sicherer Zugang",
    "auth.email_label": "E-Mail",
    "auth.password_label": "Passwort",
    "auth.new_password_label": "Neues Passwort",
    "auth.repeat_password_label": "Passwort wiederholen",
    "auth.invite_label": "Einladungscode (optional)",
    "auth.remember_me": "Angemeldet bleiben",
    "auth.agreement_accept": "Ich akzeptiere die {link}",
    "auth.agreement_link": "Nutzungsvereinbarung",
    "auth.newsletter": "Produktneuigkeiten erhalten",
    "auth.sending": "Wird gesendet…",
    "auth.have_account": "Bereits ein Konto",
    "auth.forgot_password": "Passwort vergessen?",
    "auth.art_line1": "Digitales Eigentum.",
    "auth.art_line2": "Klar durchdacht.",
    "auth.link_incomplete_title": "Unvollständiger Link",
    "auth.link_incomplete_desc": "Im Link fehlt der Aktivierungsschlüssel.",
    "auth.confirming_email": "E-Mail-Adresse wird bestätigt",
    "auth.email_confirmed_title": "E-Mail-Adresse bestätigt",
    "auth.email_confirmed_desc": "Ihr Konto ist aktiviert. Sie können fortfahren.",
    "auth.continue": "Weiter",
    "auth.preparing_invite": "Einladung wird vorbereitet",
    "auth.resent": "Die E-Mail wurde erneut gesendet.",
    "auth.email_verification": "E-Mail-Bestätigung",
    "auth.verify_email_title": "Bestätigen Sie Ihre E-Mail-Adresse",
    "auth.verify_email_desc": "Wir haben einen Aktivierungslink an die E-Mail-Adresse Ihres Kontos gesendet. Kehren Sie nach der Bestätigung hierher zurück und aktualisieren Sie den Status.",
    "auth.email_confirmed_button": "Ich habe meine E-Mail bestätigt",
    "auth.resend_email": "E-Mail erneut senden",
    "auth.username_length": "Der Benutzername muss 3 bis 20 Zeichen lang sein.",
    "auth.welcome": "Willkommen",
    "auth.choose_username": "Geben Sie einen Benutzernamen ein",
    "auth.username_hint": "So werden andere Sie im Profil sehen. Sie können den Namen später ändern.",
    "auth.username_label": "Benutzername",
    "auth.saving": "Wird gespeichert…",
    "auth.skip": "Überspringen",
    "auth.status_aria": "Kontostatus",
    "auth.status_account": "Konto",
    "auth.status_blocked": "Gesperrt",
    "auth.status_verification": "Verifizierung",
    "auth.status_verified": "Verifiziert",
    "auth.status_not_verified": "Nicht verifiziert",
    "auth.status_aml": "AML",
    "auth.status_passed": "Bestanden",
    "auth.status_not_passed": "Nicht bestanden",
    "auth.status_withdrawals": "Auszahlungen",
    "auth.status_available": "Verfügbar",
    "auth.status_restricted": "Eingeschränkt",
    "auth.chip_verified": "Konto verifiziert",
    "auth.chip_not_verified": "Konto nicht verifiziert",
    "auth.chip_withdraw_available": "Auszahlungen verfügbar",
    "auth.chip_withdraw_restricted": "Auszahlungen eingeschränkt",
    "auth.chip_aml_passed": "AML bestanden",
    "auth.chip_aml_not_passed": "AML nicht bestanden",
    "auth.main_nav": "Hauptnavigation",
    "auth.mobile_nav": "Mobile Navigation",
    "auth.tfa_enter_code": "Geben Sie den Code aus der App ein.",
    "auth.tfa_enabled": "Die Zwei-Faktor-Authentifizierung ist aktiviert.",
    "auth.tfa_disabled": "Die Zwei-Faktor-Authentifizierung ist deaktiviert.",
    "auth.tfa_unavailable": "Die Zwei-Faktor-Authentifizierung ist derzeit nicht verfügbar. Versuchen Sie es später erneut.",
    "auth.tfa_title": "Zwei-Faktor-Authentifizierung",
    "auth.tfa_on_desc": "Aktiviert: Bei der Anmeldung wird ein Code aus Ihrer Authenticator-App benötigt.",
    "auth.tfa_off_desc": "Fügen Sie Einmalcodes aus einer Authenticator-App für die Anmeldung hinzu.",
    "auth.tfa_apps_hint": "Jede Authenticator-App funktioniert:",
    "auth.tfa_secret_label": "Geheimer Schlüssel (manuell in der Authenticator-App eingeben)",
    "auth.tfa_disable": "Deaktivieren",
    "auth.tfa_preparing": "Wird vorbereitet…",
    "auth.tfa_enable": "Aktivieren",
    "auth.tfa_setup_desc": "Scannen Sie den QR-Code in Ihrer Authenticator-App oder geben Sie den Schlüssel manuell ein und bestätigen Sie dann mit einem Code.",
    "auth.tfa_qr_alt": "QR-Code für die Authenticator-App",
    "auth.cancel": "Abbrechen",
    "auth.tfa_disable_title": "Zwei-Faktor-Authentifizierung deaktivieren?",
    "auth.tfa_disable_desc": "Das verringert die Sicherheit Ihres Kontos: Zur Anmeldung genügt dann allein das Passwort.",
    "auth.devices_loading": "Geräte werden geladen",
    "auth.devices_title": "Geräte",
    "auth.devices_unavailable": "Die Geräteliste ist derzeit nicht verfügbar. Versuchen Sie es später erneut.",
    "auth.devices_desc": "Hier sehen Sie die Geräte, auf denen Sie bei Ihrem Konto angemeldet sind.",
    "auth.devices_empty": "Keine aktiven Sitzungen gefunden.",
    "auth.device_unknown": "Unbekanntes Gerät",
    "auth.device_current": "dieses Gerät",
    "auth.device_terminate": "Beenden",
    "auth.devices_terminating": "Wird beendet…",
    "auth.devices_terminate_others": "Alle anderen Sitzungen beenden",
    "auth.saved": "Änderungen gespeichert.",
    "auth.new_username_required": "Geben Sie einen neuen Benutzernamen ein.",
    "auth.new_email_required": "Geben Sie eine neue E-Mail-Adresse ein.",
    "auth.new_passwords_mismatch": "Die neuen Passwörter stimmen nicht überein.",
    "auth.current_password_required": "Geben Sie Ihr aktuelles Passwort ein.",
    "auth.password_updated": "Passwort aktualisiert.",
    "auth.avatar_type": "Verwenden Sie JPEG, PNG oder WebP.",
    "auth.avatar_size": "Das Bild darf höchstens 5 MB groß sein.",
    "auth.avatar_updated": "Avatar aktualisiert.",
    "auth.account_title": "Konto",
    "auth.account_since": "Sie sind seit {date} dabei",
    "auth.section_profile": "Profil",
    "auth.section_security": "Sicherheit",
    "auth.section_achievements": "Erfolge",
    "auth.section_preferences": "Einstellungen",
    "auth.partial_unavailable": "Einige Vorgänge sind vorübergehend nicht verfügbar.",
    "auth.avatar_alt": "Benutzeravatar",
    "auth.avatar_upload": "Neuen Avatar hochladen",
    "auth.verified_account": "Verifiziertes Konto",
    "auth.balance": "Guthaben",
    "auth.turnover": "Umsatz",
    "auth.change_username": "Namen ändern",
    "auth.change_email": "E-Mail ändern",
    "auth.email_change_hint": "Aktuell: {email}. Nach dem Speichern senden wir eine E-Mail an die neue Adresse — sie wird geändert, sobald Sie dem Link darin folgen.",
    "auth.change_password_title": "Passwort ändern",
    "auth.password_policy": "Neues Passwort: 6–20 Zeichen, mit Groß- und Kleinbuchstaben, einer Ziffer und einem Sonderzeichen.",
    "auth.current_password_label": "Aktuelles Passwort",
    "auth.repeat_new_password_label": "Neues Passwort wiederholen",
    "auth.updating": "Wird aktualisiert…",
    "auth.language_currency": "Sprache und Währung",
    "auth.currency_label": "Währung",
  },
  fr: {
    "auth.login_title": "Bon retour",
    "auth.login_subtitle": "Connectez-vous pour continuer à gérer vos actifs",
    "auth.login_submit": "Se connecter",
    "auth.signup_title": "Créer un compte",
    "auth.signup_subtitle": "Accédez aux collections",
    "auth.signup_submit": "S'inscrire",
    "auth.reset_title": "Nouveau mot de passe",
    "auth.reset_subtitle": "Saisissez votre e-mail et un nouveau mot de passe pour le compte",
    "auth.reset_submit": "Mettre à jour le mot de passe",
    "auth.code_required": "Saisissez le code de confirmation.",
    "auth.repeat_password_required": "Répétez le mot de passe.",
    "auth.passwords_mismatch": "Les mots de passe ne correspondent pas.",
    "auth.password_required": "Saisissez votre mot de passe.",
    "auth.agreement_required": "Vous devez accepter les conditions d'utilisation.",
    "auth.reset_success_title": "Mot de passe mis à jour",
    "auth.reset_success_desc": "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    "auth.go_to_login": "Aller à la connexion",
    "auth.two_factor_eyebrow": "Double authentification",
    "auth.two_factor_title": "Confirmez la connexion",
    "auth.two_factor_desc": "Saisissez le code de votre application d'authentification.",
    "auth.code_label": "Code de confirmation",
    "auth.code_placeholder": "6 chiffres",
    "auth.checking": "Vérification…",
    "auth.confirm": "Confirmer",
    "auth.back": "Retour",
    "auth.secure_access": "Accès sécurisé",
    "auth.email_label": "E-mail",
    "auth.password_label": "Mot de passe",
    "auth.new_password_label": "Nouveau mot de passe",
    "auth.repeat_password_label": "Répétez le mot de passe",
    "auth.invite_label": "Code d'invitation (facultatif)",
    "auth.remember_me": "Se souvenir de moi",
    "auth.agreement_accept": "J'accepte les {link}",
    "auth.agreement_link": "conditions d'utilisation",
    "auth.newsletter": "Recevoir les actualités du produit",
    "auth.sending": "Envoi…",
    "auth.have_account": "Déjà un compte",
    "auth.forgot_password": "Mot de passe oublié ?",
    "auth.art_line1": "Propriété numérique.",
    "auth.art_line2": "Clair par conception.",
    "auth.link_incomplete_title": "Lien incomplet",
    "auth.link_incomplete_desc": "La clé d'activation est absente du lien.",
    "auth.confirming_email": "Confirmation de l'e-mail",
    "auth.email_confirmed_title": "E-mail confirmé",
    "auth.email_confirmed_desc": "Votre compte est activé. Vous pouvez continuer.",
    "auth.continue": "Continuer",
    "auth.preparing_invite": "Préparation de l'invitation",
    "auth.resent": "L'e-mail a été renvoyé.",
    "auth.email_verification": "Vérification de l'e-mail",
    "auth.verify_email_title": "Confirmez votre adresse e-mail",
    "auth.verify_email_desc": "Nous avons envoyé un lien d'activation à l'adresse e-mail de votre compte. Après confirmation, revenez ici et actualisez le statut.",
    "auth.email_confirmed_button": "J'ai confirmé mon e-mail",
    "auth.resend_email": "Renvoyer l'e-mail",
    "auth.username_length": "Le nom d'utilisateur doit contenir de 3 à 20 caractères.",
    "auth.welcome": "Bienvenue",
    "auth.choose_username": "Saisissez un nom d'utilisateur",
    "auth.username_hint": "C'est ainsi que les autres vous verront dans votre profil. Vous pourrez le modifier plus tard.",
    "auth.username_label": "Nom d'utilisateur",
    "auth.saving": "Enregistrement…",
    "auth.skip": "Passer",
    "auth.status_aria": "Statut du compte",
    "auth.status_account": "Compte",
    "auth.status_blocked": "Bloqué",
    "auth.status_verification": "Vérification",
    "auth.status_verified": "Vérifié",
    "auth.status_not_verified": "Non vérifié",
    "auth.status_aml": "AML",
    "auth.status_passed": "Validé",
    "auth.status_not_passed": "Non validé",
    "auth.status_withdrawals": "Retraits",
    "auth.status_available": "Disponible",
    "auth.status_restricted": "Limité",
    "auth.chip_verified": "Compte vérifié",
    "auth.chip_not_verified": "Compte non vérifié",
    "auth.chip_withdraw_available": "Retraits disponibles",
    "auth.chip_withdraw_restricted": "Retraits limités",
    "auth.chip_aml_passed": "AML validé",
    "auth.chip_aml_not_passed": "AML non validé",
    "auth.main_nav": "Navigation principale",
    "auth.mobile_nav": "Navigation mobile",
    "auth.tfa_enter_code": "Saisissez le code de l'application.",
    "auth.tfa_enabled": "La double authentification est activée.",
    "auth.tfa_disabled": "La double authentification est désactivée.",
    "auth.tfa_unavailable": "La double authentification est actuellement indisponible. Réessayez plus tard.",
    "auth.tfa_title": "Double authentification",
    "auth.tfa_on_desc": "Activée : la connexion nécessitera un code de votre application d'authentification.",
    "auth.tfa_off_desc": "Ajoutez des codes à usage unique depuis une application d'authentification pour vous connecter.",
    "auth.tfa_apps_hint": "Toute application d’authentification convient :",
    "auth.tfa_secret_label": "Clé secrète (à saisir manuellement dans votre application d’authentification)",
    "auth.tfa_disable": "Désactiver",
    "auth.tfa_preparing": "Préparation…",
    "auth.tfa_enable": "Activer",
    "auth.tfa_setup_desc": "Scannez le QR code dans votre application d'authentification ou saisissez la clé manuellement, puis confirmez avec un code.",
    "auth.tfa_qr_alt": "QR code pour l'application d'authentification",
    "auth.cancel": "Annuler",
    "auth.tfa_disable_title": "Désactiver la double authentification ?",
    "auth.tfa_disable_desc": "Cela réduit la sécurité du compte : le mot de passe seul suffira pour se connecter.",
    "auth.devices_loading": "Chargement des appareils",
    "auth.devices_title": "Appareils",
    "auth.devices_unavailable": "La liste des appareils est actuellement indisponible. Réessayez plus tard.",
    "auth.devices_desc": "Voici les appareils connectés à votre compte.",
    "auth.devices_empty": "Aucune session active trouvée.",
    "auth.device_unknown": "Appareil inconnu",
    "auth.device_current": "cet appareil",
    "auth.device_terminate": "Terminer",
    "auth.devices_terminating": "Fermeture…",
    "auth.devices_terminate_others": "Terminer toutes les autres sessions",
    "auth.saved": "Modifications enregistrées.",
    "auth.new_username_required": "Saisissez un nouveau nom d'utilisateur.",
    "auth.new_email_required": "Saisissez un nouvel e-mail.",
    "auth.new_passwords_mismatch": "Les nouveaux mots de passe ne correspondent pas.",
    "auth.current_password_required": "Saisissez votre mot de passe actuel.",
    "auth.password_updated": "Mot de passe mis à jour.",
    "auth.avatar_type": "Utilisez JPEG, PNG ou WebP.",
    "auth.avatar_size": "L'image ne doit pas dépasser 5 Mo.",
    "auth.avatar_updated": "Avatar mis à jour.",
    "auth.account_title": "Compte",
    "auth.account_since": "Avec nous depuis le {date}",
    "auth.section_profile": "Profil",
    "auth.section_security": "Sécurité",
    "auth.section_achievements": "Succès",
    "auth.section_preferences": "Préférences",
    "auth.partial_unavailable": "Certaines opérations sont temporairement indisponibles.",
    "auth.avatar_alt": "Avatar de l'utilisateur",
    "auth.avatar_upload": "Téléverser un nouvel avatar",
    "auth.verified_account": "Compte vérifié",
    "auth.balance": "Solde",
    "auth.turnover": "Volume d'échanges",
    "auth.change_username": "Modifier le nom",
    "auth.change_email": "Modifier l'e-mail",
    "auth.email_change_hint": "Actuelle : {email}. Après l'enregistrement, un e-mail sera envoyé à la nouvelle adresse — elle changera dès que vous aurez suivi le lien.",
    "auth.change_password_title": "Changer le mot de passe",
    "auth.password_policy": "Nouveau mot de passe : 6 à 20 caractères, avec une majuscule, une minuscule, un chiffre et un caractère spécial.",
    "auth.current_password_label": "Mot de passe actuel",
    "auth.repeat_new_password_label": "Répétez le nouveau mot de passe",
    "auth.updating": "Mise à jour…",
    "auth.language_currency": "Langue et devise",
    "auth.currency_label": "Devise",
  },
  cn: {
    "auth.login_title": "欢迎回来",
    "auth.login_subtitle": "登录以继续管理您的资产",
    "auth.login_submit": "登录",
    "auth.signup_title": "创建账户",
    "auth.signup_subtitle": "获取收藏系列的访问权限",
    "auth.signup_submit": "注册",
    "auth.reset_title": "新密码",
    "auth.reset_subtitle": "请输入邮箱和账户的新密码",
    "auth.reset_submit": "更新密码",
    "auth.code_required": "请输入验证码。",
    "auth.repeat_password_required": "请再次输入密码。",
    "auth.passwords_mismatch": "两次输入的密码不一致。",
    "auth.password_required": "请输入密码。",
    "auth.agreement_required": "您必须接受用户协议。",
    "auth.reset_success_title": "密码已更新",
    "auth.reset_success_desc": "现在可以使用新密码登录。",
    "auth.go_to_login": "前往登录",
    "auth.two_factor_eyebrow": "双重验证",
    "auth.two_factor_title": "确认登录",
    "auth.two_factor_desc": "请输入身份验证器应用中的验证码。",
    "auth.code_label": "验证码",
    "auth.code_placeholder": "6 位数字",
    "auth.checking": "正在验证…",
    "auth.confirm": "确认",
    "auth.back": "返回",
    "auth.secure_access": "安全访问",
    "auth.email_label": "邮箱",
    "auth.password_label": "密码",
    "auth.new_password_label": "新密码",
    "auth.repeat_password_label": "确认密码",
    "auth.invite_label": "邀请码（可选）",
    "auth.remember_me": "记住我",
    "auth.agreement_accept": "我接受{link}",
    "auth.agreement_link": "用户协议",
    "auth.newsletter": "接收产品动态",
    "auth.sending": "正在发送…",
    "auth.have_account": "已有账户",
    "auth.forgot_password": "忘记密码？",
    "auth.art_line1": "数字所有权。",
    "auth.art_line2": "设计即清晰。",
    "auth.link_incomplete_title": "链接不完整",
    "auth.link_incomplete_desc": "链接中缺少激活密钥。",
    "auth.confirming_email": "正在验证邮箱",
    "auth.email_confirmed_title": "邮箱已验证",
    "auth.email_confirmed_desc": "账户已激活，可以继续使用。",
    "auth.continue": "继续",
    "auth.preparing_invite": "正在准备邀请",
    "auth.resent": "邮件已重新发送。",
    "auth.email_verification": "邮箱验证",
    "auth.verify_email_title": "请验证您的邮箱",
    "auth.verify_email_desc": "我们已向您账户的邮箱发送了激活链接。验证后请返回此处并刷新状态。",
    "auth.email_confirmed_button": "我已验证邮箱",
    "auth.resend_email": "重新发送邮件",
    "auth.username_length": "用户名长度须为 3 至 20 个字符。",
    "auth.welcome": "欢迎",
    "auth.choose_username": "输入用户名",
    "auth.username_hint": "这是其他人在您的个人资料中看到的名称，之后可以修改。",
    "auth.username_label": "用户名",
    "auth.saving": "正在保存…",
    "auth.skip": "跳过",
    "auth.status_aria": "账户状态",
    "auth.status_account": "账户",
    "auth.status_blocked": "已封禁",
    "auth.status_verification": "身份验证",
    "auth.status_verified": "已验证",
    "auth.status_not_verified": "未验证",
    "auth.status_aml": "AML",
    "auth.status_passed": "已通过",
    "auth.status_not_passed": "未通过",
    "auth.status_withdrawals": "提现",
    "auth.status_available": "可用",
    "auth.status_restricted": "受限",
    "auth.chip_verified": "账户已验证",
    "auth.chip_not_verified": "账户未验证",
    "auth.chip_withdraw_available": "可以提现",
    "auth.chip_withdraw_restricted": "提现受限",
    "auth.chip_aml_passed": "AML 已通过",
    "auth.chip_aml_not_passed": "AML 未通过",
    "auth.main_nav": "主导航",
    "auth.mobile_nav": "移动端导航",
    "auth.tfa_enter_code": "请输入应用中的验证码。",
    "auth.tfa_enabled": "双重验证已启用。",
    "auth.tfa_disabled": "双重验证已关闭。",
    "auth.tfa_unavailable": "双重验证暂不可用，请稍后重试。",
    "auth.tfa_title": "双重验证",
    "auth.tfa_on_desc": "已启用：登录时需要输入身份验证器应用中的验证码。",
    "auth.tfa_off_desc": "登录账户时使用身份验证器应用生成的一次性验证码。",
    "auth.tfa_apps_hint": "任何验证器应用均可：",
    "auth.tfa_secret_label": "密钥（请在验证器应用中手动输入）",
    "auth.tfa_disable": "关闭",
    "auth.tfa_preparing": "正在准备…",
    "auth.tfa_enable": "启用",
    "auth.tfa_setup_desc": "使用身份验证器应用扫描二维码或手动输入密钥，然后输入验证码确认。",
    "auth.tfa_qr_alt": "身份验证器应用二维码",
    "auth.cancel": "取消",
    "auth.tfa_disable_title": "关闭双重验证？",
    "auth.tfa_disable_desc": "这会降低账户安全性：仅凭密码即可登录。",
    "auth.devices_loading": "正在加载设备",
    "auth.devices_title": "设备",
    "auth.devices_unavailable": "设备列表暂不可用，请稍后重试。",
    "auth.devices_desc": "这里显示已登录您账户的设备。",
    "auth.devices_empty": "未找到活跃会话。",
    "auth.device_unknown": "未知设备",
    "auth.device_current": "本设备",
    "auth.device_terminate": "结束",
    "auth.devices_terminating": "正在结束…",
    "auth.devices_terminate_others": "结束所有其他会话",
    "auth.saved": "更改已保存。",
    "auth.new_username_required": "请输入新的用户名。",
    "auth.new_email_required": "请输入新的邮箱。",
    "auth.new_passwords_mismatch": "两次输入的新密码不一致。",
    "auth.current_password_required": "请输入当前密码。",
    "auth.password_updated": "密码已更新。",
    "auth.avatar_type": "请使用 JPEG、PNG 或 WebP 格式。",
    "auth.avatar_size": "图片大小不得超过 5 MB。",
    "auth.avatar_updated": "头像已更新。",
    "auth.account_title": "账户",
    "auth.account_since": "加入时间：{date}",
    "auth.section_profile": "个人资料",
    "auth.section_security": "安全",
    "auth.section_achievements": "成就",
    "auth.section_preferences": "偏好设置",
    "auth.partial_unavailable": "部分操作暂时不可用。",
    "auth.avatar_alt": "用户头像",
    "auth.avatar_upload": "上传新头像",
    "auth.verified_account": "已验证账户",
    "auth.balance": "余额",
    "auth.turnover": "交易额",
    "auth.change_username": "修改用户名",
    "auth.change_email": "修改邮箱",
    "auth.email_change_hint": "当前：{email}。保存后将向新地址发送邮件——点击邮件中的链接后邮箱才会更改。",
    "auth.change_password_title": "修改密码",
    "auth.password_policy": "新密码：6–20 个字符，须包含大写字母、小写字母、数字和特殊字符。",
    "auth.current_password_label": "当前密码",
    "auth.repeat_new_password_label": "确认新密码",
    "auth.updating": "正在更新…",
    "auth.language_currency": "语言和货币",
    "auth.currency_label": "货币",
  }
});
